/**
 * MainLayout Component
 * Main application layout with left sidebar and content area
 */

import { ComponentChildren } from 'preact';
import { Sidebar } from './Sidebar';

interface MainLayoutProps {
  children: ComponentChildren;
}

export function MainLayout({ children }: MainLayoutProps) {
  return (
    <div class="flex h-screen bg-base-200">
      {/* Left Sidebar */}
      <Sidebar />

      {/* Main Content Area */}
      <div class="flex-1 flex flex-col overflow-hidden">
        {children}
      </div>
    </div>
  );
}
